/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.parametrizacion': 'Parametrización',
  'sidebar.bodegastipospropiedades': 'Bodegas Tipos Propiedades',
  'bodegasTiposPropiedades.agregarBodegasTiposPropiedades': 'Crear Bodegas Tipos Propiedades',
  'bodegasTiposPropiedades.modificarBodegasTiposPropiedades': 'Editar Bodegas Tipos Propiedades',
  'bodegasTiposPropiedades.bodegaTipoPropiedadId': 'Bodega Tipo Propiedad Id',
  'bodegasTiposPropiedades.empresaId': 'Empresa Id',
  'bodegasTiposPropiedades.bodegaTipoPropiedadDescripcion': 'Descripción',
  'bodegasTiposPropiedades.VerBodegasTiposPropiedades': 'Ver Bodegas Tipos Propiedades',
  'bodegasTiposPropiedades.propiedad': 'Propiedad',
};
